import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Data, RouterLink } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { IStairType } from '@stair-craft/common/util';

interface IStairTypeLabels {
    readonly [key: string]: string;
}

const BEM_BLOCK: string = 'sc-calc-placeholder-page';

@Component({
    selector: 'sc-calc-placeholder-page',
    templateUrl: './placeholder-page.component.html',
    styleUrl: './placeholder-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,

        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export default class PlaceholderPageComponent {
    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #data: Signal<Data | undefined> = toSignal(this.#route.data);

    readonly #labels: IStairTypeLabels = {
        'l-shape': $localize`:@@stairTypeLShape:Г-образная`,
        'u-shape': $localize`:@@stairTypeUShape:П-образная`,
        spiral: $localize`:@@stairTypeSpiral:Винтовая`,
    };

    protected readonly stairType: Signal<IStairType | null> = computed(
        () => (this.#data() as { stairType?: IStairType } | undefined)?.stairType ?? null
    );

    protected readonly label: Signal<string> = computed(() => {
        const type: IStairType | null = this.stairType();
        return type ? (this.#labels[type] ?? '') : '';
    });
}
